import { render, staticRenderFns } from "./IVRs.vue?vue&type=template&id=79db5ef0"
import script from "./IVRs.vue?vue&type=script&lang=ts"
export * from "./IVRs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports